import { msg } from '@lingui/core/macro';

import type { MonthlyPeriodValue } from './types';

export const LEARNING_STATISTICS_MODE = {
    LEARNER: 'learner',
    FLEET: 'fleet',
    VESSEL: 'vessel',
} as const;

const LEARNING_STATISTICS_CONTENT_TITLE = msg`Learning statistics`;

export const LEARNING_STATISTICS_CONTENT = {
    [LEARNING_STATISTICS_MODE.LEARNER]: {
        title: LEARNING_STATISTICS_CONTENT_TITLE,
        tooltip: msg`Shows monthly stats for duration and number of completed elements and pathways finished across all training types: Mandatory, Recommended, and Library.`,
    },
    [LEARNING_STATISTICS_MODE.FLEET]: {
        title: LEARNING_STATISTICS_CONTENT_TITLE,
        tooltip: '',
    },
    [LEARNING_STATISTICS_MODE.VESSEL]: {
        title: LEARNING_STATISTICS_CONTENT_TITLE,
        tooltip: '',
    },
} as const;

export const EMPTY_MONTHLY_PERIOD_VALUE: MonthlyPeriodValue = {
    ashore: 0,
    onboard: 0,
    total: 0,
};

export const SHARED_LEARNING_STATISTICS_MONTHLY_PROGRESS = msg`Monthly progress`;
export const SHARED_LEARNING_STATISTICS_COMPLETED = msg`completed`;
export const SHARED_LEARNING_STATISTICS_THIS_WEEK = msg`this week`;
export const SHARED_LEARNING_STATISTICS_THIS_MONTH = msg`this month`;
export const SHARED_LEARNING_STATISTICS_ASHORE = msg`Ashore`;
export const SHARED_LEARNING_STATISTICS_ONBOARD = msg`Onboard`;
